import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
// layouts
import DashboardLayout from '../Layouts/dashboard';
import LogoOnlyLayout from '../Layouts/LogoOnlyLayout';
// components
import LoadingScreen from '../components/LoadingScreen';
import { PrivateRoute } from "../Auth/components/PrivateRoute";
import Dashboard from 'src/Dashboard/Dashboard';
import DataPage from 'src/Data/DataPage';
import Profile from 'src/Definitions/Account/containers/Profile'
import Role from '../Definitions/Role/containers/Role';
import RoleMenu from 'src/Definitions/RoleMenu/containers/RoleMenu';
import UserRole from 'src/Definitions/UserRole/containers/UserRole';
import ChangePassword from 'src/Definitions/ChangePassword/containers/ChangePassword';
import ExportTableCsv from 'src/Definitions/ExportTableCsv/containers/ExportTableCsv';
import Tags from 'src/Definitions/Tags/containers/Tags';
import UserManagement from 'src/UserManagement/containers/UserManagement';
import DataSetting from 'src/DataSettings/containers/DataSettings';
import AppConfigSettings from 'src/DataSettings/containers/AppConfigSettings';

import AcenteLists from 'src/Acente/containers/AcenteLists';
import MusteriList from 'src/MusteriYonetimi/containers/Musteriler';

import ForgetPassword from 'src/Auth/components/ForgetPassword';
import CouponCodeManagement from 'src/CouponCodeManagement/containers/CouponCodeManagement';
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};
let routeType = 0;
export default function Router() {

  return useRoutes([

    {
      path: '/',
      element: <PrivateRoute menuid={-1} routeType={routeType}><DashboardLayout /> </PrivateRoute>,
      children: [
        { element: <Navigate to="/home/home" replace />, index: true },
        { path: '/home/home', element: <PrivateRoute menuid={0} routeType={routeType}><PageHome /></PrivateRoute> },

        {
          path: 'account',
          children: [
            { element: <Navigate to="/Account/Profile" replace />, index: true },
            { path: 'Profile', element: <PrivateRoute menuid={0} routeType={routeType}><Profile /></PrivateRoute> },
          ],
        },
        {
          path: 'changePassword',
          children: [
            { element: <Navigate to="/ChangePassword/ChangePassword" replace />, index: true },
            { path: 'ChangePassword', element: <PrivateRoute menuid={0} routeType={routeType}><ChangePassword /></PrivateRoute> },
          ],
        },
        {
          path: 'icerik/',
          children: [
            { element: <Navigate to="/icerik/" replace />, index: true },
            // { path: 'four', element:     <PrivateRoute><PageFour /></PrivateRoute> },
            { path: 'blogpost', element: <PrivateRoute menuid={30} routeType={routeType}><PageIcerikBlogPost /></PrivateRoute> },
            { path: 'sabitsayfalarseo', element: <PrivateRoute menuid={30} routeType={routeType}><PageIcerikSabitSayfalarSeo /></PrivateRoute> },


          ],
        }
        ,
        {
          path: 'kiralasatinal/',
          children: [
            { element: <Navigate to="/kiralasatinal/basvurular" replace />, index: true },
            { path: 'basvurular', element: <PrivateRoute menuid={30} routeType={routeType}><PageKiralaSatinAl /></PrivateRoute> },


          ],
        },
        {
          path: 'kurumsalarackiralama/',
          children: [
            { element: <Navigate to="/kurumsalarackiralama/basvurular" replace />, index: true },
            { path: 'basvurular', element: <PrivateRoute menuid={30} routeType={routeType}><PageKurumsalAracKiralama /></PrivateRoute> },


          ],
        },
        {
          path: 'rentgofilo/',
          children: [
            { element: <Navigate to="/rentgofilo/basvurular" replace />, index: true },
            { path: 'basvurular', element: <PrivateRoute menuid={30} routeType={routeType}><PageRentGoFilo /></PrivateRoute> },


          ],
        },
        {
          path: 'UserManagement/',
          children: [
            { element: <Navigate to="/UserManagement/" replace />, index: true },
            // { path: 'four', element:     <PrivateRoute><PageFour /></PrivateRoute> },
            { path: 'UserManagement', element: <PrivateRoute menuid={35} routeType={routeType}><UserManagement /></PrivateRoute> },


          ],
        }, {
          path: 'DataSettings/',
          children: [
            { element: <Navigate to="/DataSettings/" replace />, index: true },
            // { path: 'four', element:     <PrivateRoute><PageFour /></PrivateRoute> },
            { path: 'DataSettings', element: <PrivateRoute menuid={36} routeType={routeType}><DataSetting /></PrivateRoute> },
            { path: 'AppConfigSettings', element: <PrivateRoute menuid={42} routeType={routeType}><AppConfigSettings /></PrivateRoute> },


          ],
        },
        {
          path: 'CouponCodeManagement/',
          children: [
            { element: <Navigate to="/CouponCodeManagement/" replace />, index: true },
            // { path: 'four', element:     <PrivateRoute><PageFour /></PrivateRoute> },
            { path: 'CouponCodeManagement', element: <PrivateRoute menuid={35} routeType={routeType}><CouponCodeManagement /></PrivateRoute> },


          ],
        },
        
        {
          path: 'MusteriYonetimi/',
          children: [
            { element: <Navigate to="/Musteriler/" replace />, index: true },
            // { path: 'four', element:     <PrivateRoute><PageFour /></PrivateRoute> },
            { path: 'Musteriler', element: <PrivateRoute menuid={35} routeType={routeType}><MusteriList /></PrivateRoute> },


          ],
        },
         {
          path: 'Acente/',
          children: [
            { element: <Navigate to="/AcenteLists/" replace />, index: true },
            // { path: 'four', element:     <PrivateRoute><PageFour /></PrivateRoute> },
            { path: 'AcenteLists', element: <PrivateRoute menuid={36} routeType={routeType}><AcenteLists /></PrivateRoute> },


          ],
        },
        {
          path: 'tanimlamalar/',
          children: [
            { element: <Navigate to="/tanimlamalar/fuar" replace />, index: true },
            // { path: 'four', element:     <PrivateRoute><PageFour /></PrivateRoute> },
            { path: 'topluyukleme', element: <PrivateRoute menuid={30} routeType={routeType}><PageCustomerUpload /></PrivateRoute> },
            { path: 'firmayukleme', element: <PrivateRoute menuid={34} routeType={routeType}><PageCompanyUpload /></PrivateRoute> },
            { path: 'turnikeverisi', element: <PrivateRoute menuid={31} routeType={routeType}><PageTurnikeVerisi /></PrivateRoute> },
            { path: 'exportTablesCsv', element: <PrivateRoute menuid={33} routeType={routeType}><ExportTableCsv /></PrivateRoute> },
            { path: 'fuar', element: <PrivateRoute menuid={4} routeType={routeType}><PageFuarTanim /></PrivateRoute> },
            { path: 'fuarDetay', element: <PrivateRoute menuid={5} routeType={routeType}><PageFairDetail /> </PrivateRoute> },
            { path: 'ulke', element: <PrivateRoute menuid={6} routeType={routeType}><PageUlkelerTanim /> </PrivateRoute> },
            { path: 'city', element: <PrivateRoute menuid={7} routeType={routeType}> <PageCity /> </PrivateRoute> },
            { path: 'sector', element: <PrivateRoute menuid={8} routeType={routeType}><PageSector /></PrivateRoute> },
            { path: 'subSector', element: <PrivateRoute menuid={9} routeType={routeType}> <PageSubSector /></PrivateRoute> },
            { path: 'user', element: <PrivateRoute menuid={10} routeType={routeType}><PageUser /> </PrivateRoute> },
            { path: 'tags', element: <PrivateRoute menuid={10} routeType={routeType}><PageTags /> </PrivateRoute> },
            { path: 'activityArea', element: <PrivateRoute menuid={28} routeType={routeType}><PageActivityArea /></PrivateRoute> },
            { path: 'interviewSubject', element: <PrivateRoute menuid={12} routeType={routeType}> <PageInterviewSubject /> </PrivateRoute> },
            { path: 'interviewResult', element: <PrivateRoute menuid={13} routeType={routeType}><PageInterviewResult /> </PrivateRoute> },
            { path: 'position', element: <PrivateRoute menuid={11} routeType={routeType}><PagePosition /> </PrivateRoute> },
            { path: 'company', element: <PrivateRoute menuid={15} routeType={routeType}><PageCompany /> </PrivateRoute> },
            { path: 'lang', element: <PrivateRoute menuid={28} routeType={routeType}><PageLanguage /> </PrivateRoute> },
            { path: 'template', element: <PrivateRoute menuid={16} routeType={routeType}><PageTemplate /> </PrivateRoute> },
            { path: 'role', element: <PrivateRoute menuid={17} routeType={routeType}><Role></Role> </PrivateRoute> },
            { path: 'rolemenu', element: <PrivateRoute menuid={21} routeType={routeType}><RoleMenu></RoleMenu> </PrivateRoute> },
            { path: 'userrole', element: <PrivateRoute menuid={27} routeType={routeType}><UserRole /> </PrivateRoute> },

          ],
        },
      ],
    },
    { path: 'SifremiUnuttum', element: <ForgetPassword></ForgetPassword> },
    {
      path: '*',
      element: <Login />,
      children: [
        { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

const PageIcerikBlogPost = Loadable(lazy(() => import('../icerik/BlogPost/containers/BlogPost')));
const PageIcerikSabitSayfalarSeo = Loadable(lazy(() => import('../icerik/SabitSayfalarSeo/containers/SabitSayfalarSeo')));

const PageKiralaSatinAl = Loadable(lazy(() => import('../KiralaSatinAl/containers/KiralaSatinAl')));
const PageKurumsalAracKiralama = Loadable(lazy(() => import('../KurumsalAracKiralama/containers/KurumsalAracKiralama')));
const PageRentGoFilo = Loadable(lazy(() => import('../RentGoFilo/containers/RentGoFilo')));
// Dashboard
const PageOne = Loadable(lazy(() => import('../Pages/PageOne')));
const PageTwo = Loadable(lazy(() => import('../Pages/PageTwo')));
const PageThree = Loadable(lazy(() => import('../Pages/PageThree')));
const PageFour = Loadable(lazy(() => import('../Pages/PageFour')));
const PageFive = Loadable(lazy(() => import('../Pages/PageFive')));
const PageSix = Loadable(lazy(() => import('../Pages/PageSix')));
const NotFound = Loadable(lazy(() => import('../Pages/Page404')));
const PageHome = Loadable(lazy(() => import('../Pages/HomePage')));

const PageCustomerUpload = Loadable(lazy(() => import('../Definitions/CustomerUpload/containers/CustomerUpload')));
const PageCompanyUpload = Loadable(lazy(() => import('../Definitions/CompanyUpload/containers/CompanyUpload')));
const PageTurnikeVerisi = Loadable(lazy(() => import('../Definitions/TurnstileDataUpload/containers/TurnstileDataUpload')));

const PageFuarTanim = Loadable(lazy(() => import('../Definitions/Fair/containers/Fair')));
const PageUlkelerTanim = Loadable(lazy(() => import('../Definitions/Country/containers/Country')));
const PageFairDetail = Loadable(lazy(() => import('../Definitions/FairDetail/containers/FairDetail')));
const PageCity = Loadable(lazy(() => import('../Definitions/City/containers/City')));
const PageSector = Loadable(lazy(() => import('../Definitions/Sector/containers/Sector')));
const PageSubSector = Loadable(lazy(() => import('../Definitions/SubSector/containers/SubSector')));
const PageUser = Loadable(lazy(() => import('../Definitions/User/containers/User')));
const PageTags = Loadable(lazy(() => import('../Definitions/Tags/containers/Tags')));
const PageActivityArea = Loadable(lazy(() => import('../Definitions/ActivityArea/containers/ActivityArea')));
const PageInterviewSubject = Loadable(lazy(() => import('../Definitions/IntertviewSubject/containers/InterviewSubject')));
const PageInterviewResult = Loadable(lazy(() => import('../Definitions/InterviewResult/containers/InterviewResult')));
const PageRole = Loadable(lazy(() => import('../Definitions/Role/containers/Role')));
const PagePosition = Loadable(lazy(() => import('../Definitions/Position/containers/Position')));
const PageCompany = Loadable(lazy(() => import('../Definitions/Company/containers/Company')));
const PageTemplate = Loadable(lazy(() => import('../Definitions/Template/containers/Template')));
const PageLanguage = Loadable(lazy(() => import('../Definitions/Language/containers/Language')));





const Pool1v1 = Loadable(lazy(() => import('../Pool/containers/Pool1v1')));
const Pool1 = Loadable(lazy(() => import('../Pool/containers/Pool1')));
const Pool2 = Loadable(lazy(() => import('../Pool/containers/Pool2')));
const Pool3 = Loadable(lazy(() => import('../Pool/containers/Pool3')));
const Pool4 = Loadable(lazy(() => import('../Pool/containers/Pool4')));
const Pool5 = Loadable(lazy(() => import('../Pool/containers/Pool5')));
const Pool6 = Loadable(lazy(() => import('../Pool/containers/Pool6')));
const Pool8 = Loadable(lazy(() => import('../Pool/containers/Pool8')));

const Pool9 = Loadable(lazy(() => import('../Pool/containers/Pool9')));
const Login = Loadable(lazy(() => import('../Auth/components/Login')));
const ProjeList = Loadable(lazy(() => import('../Pool/containers/PoolList')));

const PageKgoGiris = Loadable(lazy(() => import('../Kgo/containers/PageKgoGiris')));


const PageKgoBiletTest = Loadable(lazy(() => import('../Kgo/components/biletkart')));

